import { NzIdErrorCodeType } from './model/nz-id-error-code-type';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'nzIdErrorCodeReadable',
    standalone: true,
})
export class NzIdErrorCodeReadablePipe implements PipeTransform {

    transform(errorCode: string): any {
        const nzIdErrorCodeType = NzIdErrorCodeType[errorCode as keyof typeof NzIdErrorCodeType];
        switch (nzIdErrorCodeType.valueOf()) {
            case NzIdErrorCodeType.EXISTING_ID_BLANK:
                return 'In der Spalte Netzzuordnung-ID alt wird eine ID erwartet.';
            case NzIdErrorCodeType.NEW_ID_BLANK:
                return 'In der Spalte Netzzuordnung-ID neu wird eine ID erwartet.';
            case NzIdErrorCodeType.EXISTING_ID_NOT_EXIST:
                return '(Netzzuordnung-ID alt) in der Datenbank nicht bekannt.';
            case NzIdErrorCodeType.EXISTING_ID_DUPLICATE:
                return '(Netzzuordnung-ID alt) nicht eindeutig.';
            case NzIdErrorCodeType.NEW_ID_DUPLICATE:
                return '(Netzzuordnung-ID neu) nicht eindeutig.';
            case NzIdErrorCodeType.EXISTING_ID_NEW_ID_IDENTICAL:
                return '(Netzzuordnung-ID alt) soll auf identische ID gemappt werden.';
            case NzIdErrorCodeType.EXISTING_ID_INACTIVE:
                return '(Netzzuordnung-ID alt) ist deaktiviert.';
            case NzIdErrorCodeType.NEW_ID_NOT_AVAILABLE_ACTIVE_NZO:
                return '(Netzzuordnung-ID neu) bereits in Datenbank vorhanden.';
            case NzIdErrorCodeType.NEW_ID_NOT_AVAILABLE_INACTIVE_NZO_WITH_EA:
                return '(Netzzuordnung-ID neu) bereits als deaktivierte Netzzuordnung gekennzeichnet mit verknüpfter Anlage.';
            case NzIdErrorCodeType.PARSING_ERROR:
                return 'Genereller Verarbeitungsfehler.';
            default:
                console.error('Unknown error code: ' + errorCode);
                return 'Unbekannter Fehlertype. Bitte kontaktieren Sie den Support.';
        }
    }

}
